export const SUBSCRIBE_EMAIL_TO_NEWSLETTER = /* GraphQL */ `
    mutation subscribeEmailToNewsletter($email: String!) {
        subscribeEmailToNewsletter(email: $email) {
            status
        }
    }
`
